import axios from "@/utils/axiosHelper";

// 初始化数据
export const onGetInitDataAPI = (params) => {
    return axios({ url: `/ares/two/year/init`, method: "GET", params }, { interceptResultCode: false });
};

// 填写地址,province,city,country,address,phone,name
export const submitAddress = (params) => {
    return axios({ url: "/ares/two/year/address", method: "POST", params }, { interceptResultCode: false });
};

// 注销
export const onLogoutAPI = (params) => {
    return axios({ url: "/game/my/disable", method: "POST", params }, { interceptResultCode: false });
};

export const downloadApp = (params) => {
    return axios({ url: "/jump/download/url", method: "POST", params }, { interceptResultCode: false });
};


// WEBPACK FOOTER //
// ./src/pages/ares/secondAnniversary/api.js